import { personColor, initials, norm } from "@/lib/taskCalendar";

// Tabule „kdo kde je“ (337): každý přihlášený patří podle polohy příchodu ke stavbě
// (server pošle place_id — stavba v okruhu, i na denním výkazu), nebo je mimo stavby,
// nebo se přihlásil bez polohy. Mimo stavby stojící u sebe (ráno centrála) = jeden shluk.
export const OFF = "_off";
export const NOGPS = "_nogps";
export const OFF_COLOR = "#55555c";
export const WARN_COLOR = "#c98a12";
const CLUSTER_M = 150;

export function distM(a, b) {
  const R = 6371000, rad = (d) => (d * Math.PI) / 180;
  const dLat = rad(b.lat - a.lat), dLng = rad(b.lng - a.lng);
  const x = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(x));
}

export function buildPeople(rows) {
  return (rows || []).map((r) => {
    const hasGps = r.lat != null && r.lng != null;
    const group = r.place_id || (hasGps ? OFF : NOGPS);
    return {
      id: r.id, name: r.user_name || "—", photo: r.user_photo, phone: r.user_phone || null, initials: initials(r.user_name),
      since: r.check_in, lat: r.lat, lng: r.lng, hasGps, group, cluster: null,
      placeName: r.place_name || null,
      color: r.place_id ? personColor(r.place_id) : hasGps ? OFF_COLOR : WARN_COLOR,
      declared: r.project_id ? r.project_name : null,
    };
  });
}

// Stavby, u kterých teď někdo je (bublina s počtem + okruh).
export function buildPlaces(rows, people) {
  const m = new Map();
  (rows || []).forEach((r) => {
    if (!r.place_id || m.has(r.place_id)) return;
    m.set(r.place_id, { key: r.place_id, name: r.place_name || "Stavba", color: personColor(r.place_id), lat: r.place_lat, lng: r.place_lng, radius: r.radius_m || 100 });
  });
  return [...m.values()].map((p) => ({ ...p, count: people.filter((x) => x.group === p.key).length })).sort((a, b) => b.count - a.count);
}

// Lidé mimo stavby, kteří stojí u sebe → shluk (jen 2 a víc). Nastaví p.cluster.
export function buildClusters(people) {
  const cl = [];
  people.filter((p) => p.group === OFF).forEach((p) => {
    let c = cl.find((x) => distM(x, p) <= CLUSTER_M);
    if (!c) { c = { key: `c${cl.length}`, lat: p.lat, lng: p.lng, ids: [] }; cl.push(c); }
    c.ids.push(p.id);
  });
  const big = cl.filter((c) => c.ids.length > 1);
  big.forEach((c) => c.ids.forEach((id) => { const p = people.find((x) => x.id === id); if (p) p.cluster = c.key; }));
  return big;
}

export function buildChips(people, places) {
  const n = (k) => people.filter((p) => p.group === k).length;
  return [
    ...places.map((p) => ({ key: p.key, label: p.name, color: p.color, count: p.count })),
    ...(n(OFF) ? [{ key: OFF, label: "Mimo stavby", color: OFF_COLOR, count: n(OFF) }] : []),
    ...(n(NOGPS) ? [{ key: NOGPS, label: "Bez polohy", color: WARN_COLOR, count: n(NOGPS), warn: true }] : []),
  ];
}

export const summary = (people) => ({
  total: people.length,
  onSite: people.filter((p) => p.group !== OFF && p.group !== NOGPS).length,
  off: people.filter((p) => p.group === OFF).length,
  nogps: people.filter((p) => p.group === NOGPS).length,
});

export function filterPeople(people, { group, q }) {
  const nq = norm(q || "");
  return people.filter((p) => (!group || p.group === group || p.cluster === group) && (!nq || norm(p.name).includes(nq)));
}

// Seznam po skupinách: bez polohy (problém) první, pak stavby podle počtu, nakonec mimo stavby.
export function groupList(shown, places) {
  const g = [
    { key: NOGPS, label: "Bez polohy", color: WARN_COLOR, warn: true },
    ...places.map((p) => ({ key: p.key, label: p.name, color: p.color })),
    { key: OFF, label: "Mimo stavby", color: OFF_COLOR },
  ];
  return g.map((x) => ({ ...x, people: shown.filter((p) => p.group === x.key) })).filter((x) => x.people.length);
}

// Kdo je na mapě jako samostatné kolečko: mimo stavby (pokud není ve shluku), lidé vybrané
// stavby/shluku, vybraný člověk a výsledky hledání. Ostatní zastupuje bublina s počtem.
export function pinIds(people, { group, selId, q, visibleIds }) {
  return new Set(people.filter((p) => p.hasGps && (
    (p.group === OFF && !p.cluster) || (group && (p.group === group || p.cluster === group)) || p.id === selId || (q && visibleIds.has(p.id))
  )).map((p) => p.id));
}
